// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import { Link } from "react-router-dom";

// const Powder = () => {
//   return (
//     <>
//       <Navbar />

//       <Link to="/" className="float">
//         <img src="imgs-alu/whtsp.png" alt="" />
//       </Link>

//       <div className="container-fluid main-banner">
//         <div className="heading-main">
//           <h1 className="text-[48px] text-white font-candal text-center">
//             Powder Coating
//           </h1>
//           <h4 className="text-[17px] font-exo text-white font-medium text-center">
//             Home{" "}
//             <i className="bi bi-chevron-double-right text-light-yellow"></i>
//             Powder Coating
//           </h4>
//         </div>
//       </div>

//       <div className="container py-5">
//         <img src="imgs-alu/powder.png" alt="" className="w-full" />
//       </div>

//       <div className="container-fluid py-5 my-3 bg-yellow-2">
//         <div className="main-heading">
//           <h1>
//             P<span>owder Coati</span>ng
//           </h1>
//         </div>
//         <div className="container">
//           <div className="w-full lg:w-9/12 mx-auto">
//             <p className="font-nunito font-normal text-[20px] leading-9 text-regal-blue">
//               Flexible, long-lasting, and environmentally friendly powder
//               coating that adds color to diverse metal parts of many types of
//               equipment. <br />
//               Narayan Aluminium Alloys Pvt. Ltd aims to provide high-quality
//               products and outstanding powder coating services with assured
//               on-time deliveries and advanced production facilities based on
//               years of experience and service to various sectors. We are one of
//               the most sought-after Powder coating service suppliers in India.
//               We provide unrivaled benefits and added value to our customers.
//             </p>
//             <p className="font-nunito font-normal text-[20px] leading-9 text-regal-blue">
//               Fully automotive, environmentally friendly, efficient, and
//               dependable Powder Coating is a simple yet effective method of
//               adding a dry layer on industrial equipment or spraying a specific
//               color on metal objects. The use of an electrostatic method
//               improves the durability and longevity of color adhesion on metal
//               parts.
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="container py-4">
//         <div className="flex flex-wrap py-3">
//           <div className="w-full md:w-6/12">
//             <div className="p-3">
//               <h2 className="font-raleway font-semibold text-[24px] text-dark-yellow">
//                 The primary equipment for Powder Coating Process:
//               </h2>
//               <p className="pt-1 font-nunito font-semibold text-lg text-black leading-8">
//                 Only Narayan Aluminium Alloys Pvt. Ltd has a simple and
//                 simplified technique.
//               </p>

//               <p className="pt-1 font-nunito font-normal text-lg text-dark-gray leading-8">
//                 During powder coating, we apply electrostatic particles to the
//                 surface of a substrate. Our professionals use an electrostatic
//                 cannon to distribute powder to a feeder unit in a powder-coating
//                 system. It also regulates the flow of powder to the gun, which
//                 generates distributed clouds of powder.
//                 <br />
//                 The combination of a low-amperage power unit with an electric
//                 field charge causes charged particles to adhere to the
//                 substrate. After applying the coating, we bake the work item in
//                 an oven during the powder-coating process. Curing provides a
//                 protective layer and improves coating adhesion.
//                 <br />
//                 Curing is done at 400 degrees Fahrenheit for 20 to 30 minutes,
//                 depending on the type of powder coat. We understand that surface
//                 preparation is vital for a good powder coating operation.  To
//                 clean surfaces and attach coatings, chemicals, physical, and
//                 mechanical procedures are utilized. Chemical compounds improve
//                 the performance, longevity, and resistance to corrosion of a
//                 coating.
//               </p>
//             </div>
//           </div>
//           <div className="w-full md:w-6/12">
//             <div className="p-3">
//               <img className="w-full" src="imgs-alu/powder2.png" alt="" />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* <div className="container pb-4">
//         <div className="flex flex-wrap">
//           <div className="w-full lg:w-1/2 p-2">
//             <div className="shadow-custom-4 rounded-[16px] bg-white p-4">
//               <h2 className="font-raleway font-semibold text-[22px] text-dark-yellow mb-3">
//                 Industries that rely on our high-quality extrusion products:
//               </h2>
//               <div className="list-none">
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Electrical Sector
//                 </li>
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Construction/Architecture
//                 </li>
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Electronics/Appliances
//                 </li>
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Transportation/automotive sector
//                 </li>
//               </div>
//             </div>
//           </div>
//           <div className="w-full lg:w-1/2 p-2">
//             <div className="shadow-custom-4 rounded-[16px] bg-white p-4">
//               <h2 className="font-raleway font-semibold text-[22px] text-dark-yellow mb-3">
//                 We provide verities of industrial extrusion products, including
//                 :
//               </h2>
//               <div className="list-none">
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Electrical Sector
//                 </li>
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Construction/Architecture
//                 </li>
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Electronics/Appliances
//                 </li>
//                 <li className="flex items-center font-exo font-normal text-lg text-dark-gray mb-1">
//                   <div>
//                     <img
//                       src="imgs-alu/material-symbols_point-scan.png"
//                       alt=""
//                       className="mr-2"
//                     />
//                   </div>{" "}
//                   Transportation/automotive sector
//                 </li>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div> */}

//       <div className="container py-4">
//         <p className="font-nunito font-normal text-dark-gray text-lg ">
//           Connect with industry-leading product and service providers. More
//           information on Narayan Aluminium Alloys Pvt. Ltd’s custom Powder
//           coating services can be obtained from our technical sales specialists.
//         </p>
//       </div>

//       <div className="container enquiry">
//         <div className="main-heading">
//           <h1>
//             E<span>nquire No</span>w
//           </h1>
//         </div>
//         <div className="my-4 lg:p-5 p-3 w-full lg:w-8/12 bg-enquiry rounded-[10px] mx-auto">
//           <form action="" className="flex flex-wrap">
//             <div className="w-full md:w-6/12 p-2">
//               <div>
//                 <label
//                   htmlFor="name"
//                   className="block font-poppins font-medium text-lg mb-1"
//                 >
//                   Name
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
//                   placeholder="Name"
//                 />
//               </div>
//             </div>
//             <div className="w-full md:w-6/12 p-2">
//               <div>
//                 <label
//                   htmlFor="name"
//                   className="block font-poppins font-medium text-lg mb-1"
//                 >
//                   Phone No.
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
//                   placeholder="Phone no"
//                 />
//               </div>
//             </div>
//             <div className="w-full md:w-6/12 p-2">
//               <div>
//                 <label
//                   htmlFor="name"
//                   className="block font-poppins font-medium text-lg mb-1"
//                 >
//                   Email
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
//                   placeholder="Email"
//                 />
//               </div>
//             </div>
//             <div className="w-full md:w-6/12 p-2">
//               <div>
//                 <label
//                   htmlFor="name"
//                   className="block font-poppins font-medium text-lg mb-1"
//                 >
//                   Address
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
//                   placeholder="Address"
//                 />
//               </div>
//             </div>
//             <div className="w-full p-2">
//               <div>
//                 <label
//                   htmlFor="name"
//                   className="block font-poppins font-medium text-lg mb-1"
//                 >
//                   Message
//                 </label>
//                 <textarea
//                   type="text"
//                   className="w-full p-2 border-1 border-enquiry-border rounded-[10px] bg-transparent font-poppins font-normal text-md text-dark-gray"
//                   placeholder="Message"
//                 >
//                   {" "}
//                 </textarea>
//               </div>
//             </div>
//             <div className="p-2">
//               <button className="rounded-[10px] bg-enquiry-button font-poppins font-medium text-white text-lg py-1 px-4">
//                 Send
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Powder;


import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link, useSearchParams } from "react-router-dom";
import EnquiryForm from "./EnquiryForm";
import { useAuth } from "../../AuthContext";
import axios from 'axios';

const Powder = () => {
  const { apipath, filepath } = useAuth();
  const [powderData, setPowderData] = useState(null);
  const [searchParams] = useSearchParams();
  const pageType = searchParams.get("pageType") || "Default";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apipath}/manufacturingcms/content/${pageType}`);
        // Log the data portion of the response
        //  console.log('Response Data:', response.data);
        setPowderData(response.data);
      } catch (error) {
        console.error('Error fetching about data:', error);
      }
    };

    fetchData();
  }, [pageType]);

  if (!powderData) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Navbar />

      {/* <Link to="/" className="float">
        <img src="imgs-alu/whtsp.png" alt="" />
      </Link> */}

      <div className="container-fluid main-banner">
        <div className="heading-main">
          <h1 className="text-[48px] text-white font-candal text-center">
            Powder Coating
          </h1>
          <h4 className="text-[17px] font-exo text-white font-medium text-center">
            Home{" "}
            <i className="bi bi-chevron-double-right text-light-yellow"></i>
            Powder Coating
          </h4>
        </div>
      </div>

      <div className="container py-5">
        <img src={filepath + powderData.bannerImage} alt="" className="w-full" />
      </div>

      <div className="container-fluid py-5 my-3 bg-yellow-2">
        <div className="main-heading">
          <h1>
          {powderData.maintitle}
          </h1>
        </div>
        <div className="container">
          <div className="w-full lg:w-9/12 mx-auto">
            <p className="font-nunito font-normal text-[20px] leading-9 text-regal-blue">
              {powderData.headContent}
            </p>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <div className="flex flex-wrap py-3">
          <div className="w-full md:w-6/12">
            <div className="p-3">
              <h2 className="font-raleway font-semibold text-[24px] text-dark-yellow">
              {powderData.body1title}
              </h2>
              <p className="pt-1 font-nunito font-semibold text-lg text-black leading-8">
              {powderData.body1content[0].content}
              </p>

              <p className="pt-1 font-nunito font-normal text-lg text-dark-gray leading-8">
              {powderData.body1content[1].content}
              </p>
            </div>
          </div>
          <div className="w-full md:w-6/12">
            <div className="p-3">
              <img className="w-full" src={filepath + powderData.sideImage} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <p className="font-nunito font-normal text-dark-gray text-lg ">
          {powderData.bottomstatement}
        </p>
      </div>

      <EnquiryForm />

      <Footer />
    </>
  );
};

export default Powder;
